import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Suppliers() {
    const [suppliers, setSuppliers] = useState([]);
    const [newSupplier, setNewSupplier] = useState({ name: '', contact: '', address: '', email: '' });

    useEffect(() => {
        fetchSuppliers();
    }, []);

    const fetchSuppliers = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/suppliers`);
            setSuppliers(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddSupplier = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${getApiUrl()}/suppliers`, newSupplier);
            setNewSupplier({ name: '', contact: '', address: '', email: '' });
            fetchSuppliers();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Suppliers</h2>
                <form onSubmit={handleAddSupplier} className="mb-4">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Supplier Name" value={newSupplier.name} onChange={e => setNewSupplier({...newSupplier, name: e.target.value})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Contact" value={newSupplier.contact} onChange={e => setNewSupplier({...newSupplier, contact: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Address" value={newSupplier.address} onChange={e => setNewSupplier({...newSupplier, address: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-3">
                            <input type="email" className="form-control" placeholder="Email" value={newSupplier.email} onChange={e => setNewSupplier({...newSupplier, email: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-1 d-grid">
                            <button type="submit" className="btn btn-primary">Add</button>
                        </div>
                    </div>
                </form>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Contact</th>
                                <th>Address</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {suppliers.map(s => (
                                <tr key={s.id}>
                                    <td>{s.name}</td>
                                    <td>{s.contact}</td>
                                    <td>{s.address}</td>
                                    <td>{s.email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
}

export default Suppliers;
